export const businessInformationState = {
  allBusinessInformations: [],
  userBusinessInformation: null,
};
